export const MOBILE_DEPTH_CLASSES = ["pl-3", "pl-6", "pl-9", "pl-12"] as const;

export function mobileDepthClass(depth: number) {
  return MOBILE_DEPTH_CLASSES[Math.min(depth, MOBILE_DEPTH_CLASSES.length - 1)];
}
